import React__default from 'react';
import styled, { css } from 'styled-components';
import { B as Button } from '../../Button/Button-rs5QufkK.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';

const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30061128__sc-bareo-0"
})(["display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center;width:", ";", ""], ({
  theme
}) => theme.pagination.button.width, isMobile(css(["width:", ";height:", ";"], ({
  theme
}) => theme.pagination.button.mobile.width, ({
  theme
}) => theme.pagination.button.mobile.height)));

// eslint-disable-next-line @typescript-eslint/no-empty-interface

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const PageNavButton = withTaktFallbackId(StyledButton);
const PaginationButton = props => {
  const {
    id,
    ariaLabel,
    onClick,
    children,
    disabled,
    taktId,
    taktValue,
    taktFallbackId
  } = props;
  return /*#__PURE__*/React__default.createElement(PageNavButton, {
    id: id,
    onClick: onClick,
    "aria-label": ariaLabel,
    disabled: disabled,
    taktId: taktId,
    taktValue: taktValue,
    taktFallbackId: taktFallbackId
  }, children);
};
PaginationButton.defaultProps = {
  disabled: false,
  taktFallbackId: undefined
};

export { PaginationButton as P };
//# sourceMappingURL=PaginationButton-CNkswew5.js.map
